import {
  CheckCircleOutlined,
  EllipsisOutlined,
  PlusOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Spin,
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import ItemPrint from "../../../components/print/print_item";
import SelectLayoutNew from "../../../components/select-layout/SelectLayoutNew";
import SelectMaterialHandling from "../../../components/SelectMaterialHandling";
import SelectOperator from "../../../components/SelectOperator";
import SelectOwner from "../../../components/SelectOwner";
import SelectProductByClient from "../../../components/SelectProductByClient";
import UserManualButton from "../../../components/UserManualButton";
import { baseUrl } from "../../../config/url-config";
import API from "../../../services/api-request";
import Process from "./process";

function hasDestinationConflict(A, product_data) {
  for (const item of A) {
    const match = product_data.find(
      (p) => p.pallet_id === item.pallet_destination_id,
    );

    if (match && match.product_id !== item.product_id) {
      return true;
    }
  }
  return false;
}

const AddOutbound = () => {
  const navigate = useNavigate();
  const [selectionIndex, setSelectionIndex] = useState(0);
  const [selectedArea, setSelectedArea] = useState({});
  const [addForm] = Form.useForm();

  const [clientId, setClientId] = useState("");
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [openProcess, setOpenProcess] = useState(false);

  const [dataPallet, setDataPallet] = useState([]);
  const [loadingPallet, setLoadingPallet] = useState(false);
  const [triggerRender, setTriggerRender] = useState(false);

  const [isCustomMaterialHandling, setIsCustomMaterialHandling] =
    useState(false);
  const [materialHandlingChecked, setMaterialHandlingChecked] = useState(false);
  const [selectedPallet, setSelectedPallet] = useState(null);
  const [productData, setProductData] = useState([]);

  const [confirmOutbound, setConfirmOutbound] = useState(false);

  // Track field berat mana yang diklik user
  const [activeField, setActiveField] = useState(null);

  const getPallet = async () => {
    if (!clientId) return;

    setLoadingPallet(true);
    try {
      const res = await API.Get(
        `transaction/outbound/list-pallet?client_id=${clientId}`,
      );
      setDataPallet(res?.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingPallet(false);
    }
  };

  useEffect(() => {
    getPallet();
  }, [clientId]);

  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOk = (value) => {
    addForm.setFieldValue(["products", selectionIndex, "area_id"], value.id);
    addForm.setFieldValue(["products", selectionIndex, "area"], value.name);
    addForm.setFieldValue(["products", selectionIndex, "level"], value.level);
    addForm.setFieldValue(
      ["products", selectionIndex, "warehouse"],
      value.warehouse_name,
    );

    setOpen(false);
    setSelectedArea({});
  };

  const showModalProcess = () => {
    setOpenProcess(true);
  };

  const handleCancelProcess = () => {
    setOpenProcess(false);
  };

  const handleOkProcess = (data, weighingCount) => {
    if (
      data.pallet.id &&
      dataPallet[selectionIndex]?.pallet_id !== data.pallet.id
    ) {
      message.warning("Pallet tidak dimiliki client!");
      return;
    }

    onSelectedPallet(data.pallet.id, data.pallet, selectionIndex);

    if (data.pallet.id) {
      addForm.setFieldValue(
        ["products", selectionIndex, "pallet_id"],
        data.pallet.id,
      );
    }

    if (data.operator.id) {
      addForm.setFieldValue(
        ["products", selectionIndex, "operator_id"],
        data.operator.id,
      );
    }

    /*
     * Alternate antara field weight dan remaining_weight
     * (ganjil genap berdasarkan weighingCount)
     */
    if (weighingCount % 2 === 1) {
      // (1, 3, 5, ...) → weight
      addForm.setFieldValue(
        ["products", selectionIndex, "weight"],
        data.weight.weight,
      );
    } else {
      // (2, 4, 6, ...) → remaining_weight
      addForm.setFieldValue(
        ["products", selectionIndex, "remaining_weight"],
        data.weight.weight,
      );
    }

    if (activeField) {
      message.success(
        `Penimbangan ${
          activeField === "remaining_weight" ? "berat sisa" : "berat"
        } berhasil!`,
      );
    } else {
      message.success(`Penimbangan ke-${weighingCount} berhasil!`);
    }
  };

  const onSelectOwner = (value, options) => {
    setDataPallet([]);
    addForm.setFieldValue("products", [{}]);
    addForm.setFieldValue("client_id", value);
    setClientId(value);
  };

  const onSelectProduct = (value, option, index) => {
    addForm.setFieldValue("id", value);
    addForm.setFieldValue(["products", index, "qty"], option?.quantity);
    addForm.setFieldValue(["products", index, "id"], value);
    addForm.setFieldValue(["products", index, "pallet_id"], option?.pallet_id);
    addForm.setFieldValue(["products", index, "area_id"], option?.area_id);
    addForm.setFieldValue(["products", index, "area"], option?.area);
    addForm.setFieldValue(
      ["products", index, "original_area_id"],
      option?.area_id,
    );
    addForm.setFieldValue(["products", index, "original_area"], option?.area);
    addForm.setFieldValue(["products", index, "level"], option?.level);
    addForm.setFieldValue(
      ["products", index, "warehouse"],
      option?.warehouse_name,
    );
    addForm.setFieldValue(
      ["products", index, "product_id"],
      option?.product_id,
    );
    addForm.setFieldValue(["products", index, "name"], option?.name);
    addForm.setFieldValue(
      ["products", index, "specification"],
      option?.specification,
    );
    addForm.setFieldValue(
      ["products", index, "schedule_at"],
      option?.schedule_at,
    );

    const pallet = dataPallet.find(
      (pallet) => +pallet.pallet_id === +option?.pallet_id,
    );

    addForm.setFieldValue(["products", index, "pallet_type"], pallet?.type);

    if (pallet?.type === "besi") {
      addForm.setFieldValue(["products", index, "pallet_weight"], 85);
    } else {
      addForm.setFieldValue(["products", index, "pallet_weight"], "");
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const {
        client_id,
        products,
        note,
        // material_handling_fee_type,
        material_handling_fee_cost,
      } = values;

      let dataForm = {
        client_id,
        schedule_at: dayjs().format("YYYY-MM-DD"),
        products: products.map((e) => {
          return {
            id: e.id,
            product_id: e.product_id,
            operator_id: e.operator_id,
            pallet_id: e.pallet_id,
            name: e.name,
            specification: e.specification,
            weight: e.weight,
            schedule_at: e.schedule_at,
            qty: e.qty === undefined ? 0 : e.qty,
            remaining_weight:
              e.remaining_weight === undefined
                ? 0
                : Number.parseFloat(e.remaining_weight),
            pallet_destination_id:
              e.pallet_destination_id === undefined
                ? null
                : e.pallet_destination_id,
            area_id: e.area_id === undefined ? null : e.area_id,
            is_depleted: e.is_depleted ?? false,
          };
        }),
        note,
        material_handling_fee_cost: material_handling_fee_cost || 0,
      };

      const palletIdSameWithPalletDestination = dataForm.products.find(
        (e) => e.pallet_id === e.pallet_destination_id,
      );

      if (palletIdSameWithPalletDestination) {
        message.warning("Pallet asal dan tujuan tidak boleh sama.");
        return;
      }

      if (hasDestinationConflict(dataForm.products, productData)) {
        message.warning(
          "Ada pallet tujuan yang memiliki produk berbeda. Silahkan cek kembali.",
        );
        return;
      }

      const areaMap = new Map();

      for (const row of dataForm.products) {
        if (!row.area_id) continue;

        const existing = areaMap.get(row.area_id);

        if (existing) {
          const allowed =
            row.pallet_destination_id || existing.pallet_destination_id;

          if (!allowed) {
            message.warning(
              "Area tidak boleh sama dengan pallet lain kecuali menggunakan pallet tujuan.",
            );
            return;
          }
        } else {
          areaMap.set(row.area_id, row);
        }
      }

      if (dataForm.products.length < 1) {
        message.info("Belum scan RFID");
      } else {
        await API.Post("transaction/outbound/direct", dataForm);
        message.success("Outbound has been added");
        addForm.resetFields();
        handleBack();
      }
    } catch (err) {
      console.log(err);
      message.info(`${err?.response?.data?.error}`);
    } finally {
      setLoading(false);
      setConfirmOutbound(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    setConfirmOutbound(false);
    console.log("Failed:", errorInfo);
  };

  const handleBack = () => {
    navigate("/outbound");
  };

  const items = (index, remove) => [
    {
      label: "Print",
      onClick: () => {
        handlePrint(index);
      },
    },
    {
      label: "Print from Android",
      onClick: () => {
        handlePrint(index, true);
      },
    },
    {
      label: "Delete",
      onClick: () => remove(index),
    },
  ];

  const handlePrint = async (index = null, thermer = false) => {
    const allProducts = addForm.getFieldValue("products") || [];
    const scheduleAt = addForm.getFieldValue("schedule_at") || null;
    const palletName = selectedPallet?.label;

    const productsToPrint = index === null ? allProducts : [allProducts[index]];

    const validProducts = productsToPrint.filter((product) => product?.area_id);

    if (validProducts.length === 0) {
      return message.info(
        index === null
          ? "Tidak ada data yang bisa dicetak."
          : "Data di baris ini belum lengkap untuk dicetak.",
      );
    }

    if (thermer) {
      let url = "area/response";

      const params = new URLSearchParams();

      if (validProducts?.[0]?.warehouse) {
        params.append("warehouseName", validProducts?.[0]?.warehouse);
      }
      if (validProducts?.[0]?.area) {
        params.append("areaName", validProducts?.[0]?.area);
      }
      if (scheduleAt) {
        params.append("tanggal", dayjs(scheduleAt).format("DD-MM-YYYY"));
      }
      if (palletName) {
        params.append("palletNo", palletName);
      }

      const queryString = params.toString();
      if (queryString) {
        url += `?${queryString}`;
      }

      window.open(
        `my.bluetoothprint.scheme://${baseUrl + "/" + url}`,
        "_blank",
      );

      return;
    }

    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(ItemPrint(validProducts));
    setTimeout(function () {
      printWindow.document.close();
    }, 2000);

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print({ showPrintDialog: true });

      printWindow.onafterprint = () => {
        printWindow.close();
      };
    };
  };

  const onSelectedPallet = (value, options, index) => {
    if (!value || index === undefined) return;

    setSelectedPallet(options);

    const updatedFields = {
      pallet_name: options?.label || "",
      pallet_weight: options?.type === "besi" ? 80 : "",
    };

    Object.entries(updatedFields).forEach(([key, val]) => {
      addForm.setFieldValue(["products", index, key], val);
    });

    fetchProductsByPalletAndClient(clientId, value, index);
  };

  const onSelectedMaterialHandling = (value, options) => {
    addForm.setFieldValue("material_handling_fee_type", value);
    addForm.setFieldValue("material_handling_fee_cost", options?.cost);
    setIsCustomMaterialHandling(value === "custom");
  };

  const onSelectedDestinationPallet = (value, index) => {
    if (!value) {
      const originalAreaId = addForm.getFieldValue([
        "products",
        index,
        "original_area_id",
      ]);

      const originalArea = addForm.getFieldValue([
        "products",
        index,
        "original_area",
      ]);

      addForm.setFieldValue(["products", index, "area_id"], originalAreaId);
      addForm.setFieldValue(["products", index, "area"], originalArea);
      return;
    }

    const pallet = productData.find((e) => e.pallet_id === value);

    if (pallet) {
      addForm.setFieldValue(["products", index, "area_id"], pallet.area_id);
      addForm.setFieldValue(["products", index, "area"], pallet.area_name);
    }
  };

  const fetchProductsByPalletAndClient = async (
    clientIdParam,
    palletId,
    index,
  ) => {
    if (!clientIdParam || !palletId) return;
    const url = `transaction/outbound/list-product?client_id=${clientIdParam}&pallet_id=${palletId}`;

    try {
      const res = await API.Get(url);
      const data = res?.data;

      data.map((item) => {
        addForm.setFieldValue("id", item?.id);
        addForm.setFieldValue(
          ["products", index, "pallet_id"],
          item?.pallet_id,
        );
        addForm.setFieldValue(["products", index, "area_id"], item?.area_id);
        addForm.setFieldValue(["products", index, "area"], item?.area_name);
        addForm.setFieldValue(["products", index, "level"], item?.level);
        addForm.setFieldValue(["products", index, "qty"], item?.quantity);
        addForm.setFieldValue(
          ["products", index, "warehouse"],
          item?.warehouse_name,
        );
        addForm.setFieldValue(
          ["products", index, "product_id"],
          item?.product_id,
        );
        addForm.setFieldValue(["products", index, "select_product"], item?.id);
        addForm.setFieldValue(["products", index, "name"], item?.name);
        addForm.setFieldValue(
          ["products", index, "specification"],
          item?.specification,
        );
        addForm.setFieldValue(
          ["products", index, "schedule_at"],
          item?.schedule_at,
        );
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <Form
        form={addForm}
        name="Add Form"
        style={{
          margin: "0 auto",
        }}
        layout="vertical"
        autoComplete="off"
        initialValues={{
          products: [{}], // Memberikan default 1 item kosong
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row justify={"space-between"} align={"middle"}>
          <Col lg={12} md={12} sm={12} xs={24}>
            <h2>New Outbound</h2>
          </Col>
          <Col lg={6} md={6} sm={6} xs={24}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
              }}
            >
              <Button
                type="primary"
                icon={<PrinterOutlined />}
                style={{
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  borderColor: "#4caf50",
                  width: "100%",
                }}
                onClick={() => handlePrint()}
              >
                Print All
              </Button>

              <UserManualButton />
            </div>
          </Col>
        </Row>
        <hr />
        <br />
        <Row gutter={[8, 8]}>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item
              label="Nama Pemilik"
              name="client_id"
              rules={[
                {
                  required: true,
                  message: "Please input your Nama Pemilik!",
                },
              ]}
            >
              <SelectOwner onChange={onSelectOwner} />
            </Form.Item>
          </Col>
          <Col lg={6} md={6} sm={6} xs={24}>
            <Form.Item
              label={
                <span>
                  <Checkbox
                    checked={materialHandlingChecked}
                    onChange={() => {
                      setMaterialHandlingChecked(!materialHandlingChecked);
                      addForm.setFieldValue("material_handling_fee_type", null);
                      addForm.setFieldValue("material_handling_fee_cost", null);
                      setIsCustomMaterialHandling(false);
                    }}
                  />{" "}
                  Material Handling
                </span>
              }
              name="material_handling_fee_type"
            >
              <SelectMaterialHandling
                onChange={onSelectedMaterialHandling}
                disabled={!materialHandlingChecked}
              />
            </Form.Item>
          </Col>
          <Col lg={6} md={6} sm={6} xs={24}>
            <Form.Item
              label="Material Handling Fee per kg"
              name="material_handling_fee_cost"
            >
              <InputNumber
                placeholder="Material Handling Fee"
                prefix="Rp"
                min={0}
                controls={false}
                style={{
                  width: "100%",
                }}
                disabled={!materialHandlingChecked}
                readOnly={!isCustomMaterialHandling}
              />
            </Form.Item>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Form.Item label="Silahkan Scan RFID">
              <Form.List name="products">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map((field, index) => (
                      <Row key={field.key} gutter={[2, 2]} align="top">
                        {/* Pallet */}
                        <Col flex={"2rem"}>
                          <Form.Item
                            {...field}
                            name={[field.name, "pallet_id"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input jenis pallet!",
                              },
                            ]}
                          >
                            <Select
                              style={{ width: "6rem" }}
                              allowClear
                              showSearch
                              optionFilterProp="label"
                              placeholder="Pilih Pallet"
                              notFoundContent={
                                loadingPallet ? (
                                  <Row justify={"center"}>
                                    <Spin size="small" className="center" />
                                  </Row>
                                ) : (
                                  "No Data"
                                )
                              }
                              options={dataPallet?.map((e) => ({
                                label: e.name,
                                value: e.pallet_id,
                                // type: e.type,
                              }))}
                              onChange={(value, options) => {
                                onSelectedPallet(value, options, index);
                              }}
                            />
                          </Form.Item>
                        </Col>

                        {/* Operator */}
                        <Col span={3}>
                          <Form.Item
                            {...field}
                            name={[field.name, "operator_id"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input jenis operator!",
                              },
                            ]}
                          >
                            <SelectOperator />
                          </Form.Item>
                        </Col>

                        {/* Jenis Produk */}
                        <Col span={3}>
                          <Form.Item
                            {...field}
                            name={[field.name, "select_product"]}
                            rules={[
                              {
                                required: true,
                                message: "Please input jenis produk!",
                              },
                            ]}
                          >
                            <SelectProductByClient
                              onChange={(value, option) => {
                                onSelectProduct(value, option, index);
                                setSelectionIndex(index);
                              }}
                              client_id={clientId}
                              setProductData={setProductData}
                            />
                          </Form.Item>
                        </Col>

                        {/* Berat */}
                        <Col span={2}>
                          <Form.Item
                            {...field}
                            name={[field.name, "weight"]}
                            rules={[
                              {
                                required: true,
                                message:
                                  "Berat minimum adalah 80 untuk pallet besi!",
                                type: "number",
                                min:
                                  addForm.getFieldValue([
                                    "products",
                                    index,
                                    "pallet_type",
                                  ]) === "besi"
                                    ? 80
                                    : 0,
                              },
                            ]}
                          >
                            <InputNumber
                              placeholder="Berat"
                              suffix={"Kg"}
                              min={0}
                              controls={false}
                              style={{ width: "100%" }}
                              step={"0.1"}
                              onFocus={() => setActiveField("weight")}
                            />
                          </Form.Item>
                        </Col>
                        {/*Jumlah Pack */}
                        <Col span={2}>
                          <Form.Item {...field} name={[field.name, "qty"]}>
                            <InputNumber
                              placeholder="Pack"
                              min={0}
                              controls={false}
                              style={{ width: "100%" }}
                              suffix={"Pack"}
                            />
                          </Form.Item>
                        </Col>
                        <Col flex={"2rem"}>
                          <Form.Item
                            {...field}
                            name={[field.name, "pallet_destination_id"]}
                          >
                            <Select
                              style={{ width: "6rem" }}
                              allowClear
                              showSearch
                              optionFilterProp="label"
                              placeholder="Pallet Tujuan"
                              notFoundContent={
                                loadingPallet ? (
                                  <Row justify={"center"}>
                                    <Spin size="small" className="center" />
                                  </Row>
                                ) : (
                                  "No Data"
                                )
                              }
                              options={dataPallet?.map((e) => ({
                                label: e.name,
                                value: e.pallet_id,
                              }))}
                              onChange={(value) => {
                                onSelectedDestinationPallet(value, index);
                                setTriggerRender(!triggerRender);

                                if (value) {
                                  addForm.setFieldValue(
                                    ["products", index, "is_depleted"],
                                    true,
                                  );
                                } else {
                                  addForm.setFieldValue(
                                    ["products", index, "is_depleted"],
                                    false,
                                  );
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>
                        {/* Berat Sisa*/}
                        <Col span={2}>
                          <Form.Item
                            {...field}
                            name={[field.name, "remaining_weight"]}
                            rules={[
                              {
                                message:
                                  "Berat minimum adalah 80 untuk pallet besi!",
                                type: "number",
                                min:
                                  addForm.getFieldValue([
                                    "products",
                                    index,
                                    "pallet_type",
                                  ]) === "besi"
                                    ? 80
                                    : 0,
                              },
                            ]}
                          >
                            <InputNumber
                              style={{
                                width: "100%",
                              }}
                              controls={false}
                              min={0}
                              placeholder="Sisa"
                              suffix={"Kg"}
                              step={"0.1"}
                              onFocus={() => setActiveField("remaining_weight")}
                            />
                          </Form.Item>
                        </Col>

                        {/* Area */}
                        <Col flex={"6rem"}>
                          <Form.Item {...field} name={[field.name, "area"]}>
                            <Input
                              placeholder="Pilih Area"
                              readOnly
                              onClick={() => {
                                showModal();
                                setSelectionIndex(index);
                              }}
                            />
                          </Form.Item>
                        </Col>

                        {/* Hapus */}
                        <Col
                          span={1}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Form.Item>
                            <Dropdown
                              menu={{ items: items(index, remove) }}
                              trigger={["click"]}
                            >
                              <EllipsisOutlined />
                            </Dropdown>
                          </Form.Item>
                        </Col>

                        <Col span={1}>
                          <Button
                            type="primary"
                            style={{
                              backgroundColor: "#4caf50",
                              color: "#fff",
                              borderColor: "#4caf50",
                              width: "100%",
                            }}
                            onClick={() => {
                              setSelectionIndex(index);
                              showModalProcess();
                            }}
                          >
                            Process
                          </Button>
                        </Col>
                        <Col span={1}>
                          <Button
                            // disabled={addForm.getFieldValue([
                            //   "products",
                            //   index,
                            //   "pallet_destination_id",
                            // ])}
                            icon={
                              <CheckCircleOutlined
                                style={{
                                  color: addForm.getFieldValue([
                                    "products",
                                    index,
                                    "is_depleted",
                                  ])
                                    ? "red"
                                    : "gray",
                                }}
                              />
                            }
                            color="default"
                            variant="text"
                            style={{
                              border: "none",
                            }}
                            onClick={() => {
                              let isDepleted = addForm.getFieldValue([
                                "products",
                                index,
                                "is_depleted",
                              ]);

                              setTriggerRender(!triggerRender);

                              addForm.setFieldValue(
                                ["products", index, "is_depleted"],
                                !isDepleted,
                              );
                            }}
                          >
                            <span style={{ fontWeight: "lighter" }}>
                              Pallet tidak menyisa
                            </span>
                          </Button>
                        </Col>
                      </Row>
                    ))}
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                      style={{ width: "100%" }}
                    >
                      Tambah Baris
                    </Button>
                  </>
                )}
              </Form.List>
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Button
              style={{
                width: "100%",
                backgroundColor: "orange",
                borderColor: "orange",
                color: "white",
              }}
              type="primary"
              onClick={() => handleBack()}
            >
              Kembali
            </Button>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Button
              onClick={() => {
                setConfirmOutbound(true);
              }}
              style={buttonStyle}
              type="primary"
              loading={loading}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
      <Modal
        title="Silahkan Pilih Rak"
        okText="Ok"
        cancelText="Tutup"
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        okType={"primary"}
        width="80%"
        height="80%"
        footer={null}
      >
        <SelectLayoutNew
          value={selectedArea?.id}
          onChange={(value) => {
            handleOk(value);

            setSelectedArea(value);
          }}
        />
      </Modal>

      <Modal
        title="Konfirmasi Outbound"
        okText="Ok"
        cancelText="Tutup"
        open={confirmOutbound}
        onOk={() => addForm.submit()}
        confirmLoading={loading}
        onCancel={() => setConfirmOutbound(false)}
        okType={"primary"}
      >
        <p>
          Anda akan menyimpan outbound. Apakah data yang diisi sudah sesuai?
        </p>
        <p style={{ color: "red" }}>Data yang tersimpan tidak dapat diubah.</p>
      </Modal>

      <Process
        openProcess={openProcess}
        setOpenProcess={handleCancelProcess}
        handleOkProcess={handleOkProcess}
        onSelectedPallet={onSelectedPallet}
        selectionIndex={selectionIndex}
        activeField={activeField}
        setActiveField={setActiveField}
      />
    </>
  );
};

const buttonStyle = {
  width: "100%",
};

export default AddOutbound;
